<template>
  <div class="main">
    <div v-if="queryList.length > 0">
      <el-table
        :data="queryList"
        class="table-content"
        :height="tableHeight"
        ref="paramRef"
        :row-style="{ height: rowHeight + 'px' }"
        :cell-style="{ padding: 6.3 + 'px' }"
      >
        <el-table-column align="center" label="序号" type="index" width="50px" />
        <el-table-column
          align="center"
          label="院校名称"
          prop="institutionName"
          :show-overflow-tooltip="false"
          width="150"
        />
        <el-table-column align="center" label="考点名称" prop="title" :show-overflow-tooltip="false" width="200" />
        <el-table-column align="center" label="报名费用" prop="price">
          <template slot-scope="scope"> {{ scope.row.actualPrice || 0 }}元 </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="报名时间"
          prop="applyStartTime ,applyEndTime"
          :show-overflow-tooltip="false"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.applyStartTime | parseTime }} ~<br />{{ scope.row.applyEndTime | parseTime }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="缴费时间"
          prop="applyStartTime ,applyEndTime"
          :show-overflow-tooltip="false"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.payStartTime | parseTime }} ~<br />{{ scope.row.payEndTime | parseTime }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="考试时间"
          prop="startTime ,endTime"
          :show-overflow-tooltip="false"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.startTime | parseTime }} ~<br />{{ scope.row.endTime | parseTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="报考状态" prop="status.msg" width="120" />
        <el-table-column align="center" label="审核意见" prop="examineDesc" :show-overflow-tooltip="false" width="150">
          <template slot-scope="scope">
            <Popover :text="scope.row.examineDesc" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" prop="status" width="200">
          <template slot-scope="{ row }">
            <!-- 审核不通过 {{ row.status.code }} -->
            <!-- {{ row.status.code }} {{ row.examStatus.code }} -->
            <el-button
              v-if="row.examStatus.code === 4 && diffTime(row.examineEndTime)"
              type="primary"
              size="small"
              class="button-style"
              @click="handleEdite(row)"
              >查看</el-button
            >
            <!-- <el-button v-if="row.examStatus.code === 4" type="primary" size="small" class="button-style"
              @click="handleDetail(row)">原因</el-button> -->
            <!--  && row.status.code === 1 -->
            <el-button
              v-if="(row.examStatus.code === 3 || row.examStatus.code === 5) && rangeTime(row.payTimes)"
              type="primary"
              size="small"
              class="button-style"
              @click="toPay(row)"
              >缴费 {{ row.examModel.payType }}</el-button
            >
            <!-- row.examModel?.payType  -->
            <el-button
              v-if="(row.examStatus.code === 3 || row.examStatus.code === 5) && rangeTime(row.payTimes) && row.payType.code === 2"
              type="primary"
              size="small"
              class="button-style"
              @click="paymentVoucherShow(row)"
              >上传支付凭证</el-button
            >
            <!-- 审核通过 -->
            <div v-if="row.examStatus.code == 6">已缴费</div>
            <!-- <div v-if="row.status.code === 2">报名结束</div> -->
            <!-- <div v-if="row.status.code === 3">打印准考证</div>
              <div v-if="row.status.code === 4">成绩查询</div> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-empty v-else class="enpty" description="暂无报名信息"></el-empty>

    <!-- 报名弹窗 -->
    <modal
      :modalShow="modalShow"
      @cancel="modalShow = false"
      @close="modalShow = false"
      @register="register"
      :row="row"
      isFirst="false"
    >
    </modal>
    <!-- 审核不通过原因 -->
    <el-dialog
      title="审核不通过原因："
      :visible.sync="detailVisible"
      width="30%"
      class="detail-dialog"
      :before-close="handleClose"
    >
      <span class="detail-texts">{{ detailText }}</span>
    </el-dialog>
    <!-- 缴费弹窗 -->
    <pay-qr-dialog :visible.sync="showPayDialog" :id="row.examId" :qrUrl="qrUrl" />
    <!-- 设置支付凭证 -->
    <paymentVoucher :pvData="pvData" @paymentVoucherClose="paymentVoucherClose"></paymentVoucher>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { parseTime } from '@/utils/time'
import { getPay, getSubjectByExamId } from '../api/registrationQuery'
import Modal from './registrationModal.vue'
import PayQrDialog from './PayQrDialog.vue'
import moment from 'moment'
import paymentVoucher from "@/components/paymentVoucher.vue";
export default {
  mounted() {

    const {institutionId,userIdCardBack,userIdCardFront,avatar} = JSON.parse(localStorage.getItem('fstat'))
    if(!(institutionId&&userIdCardBack&&userIdCardFront&&avatar)){
      this.$message.warning('请在“个人中心”完善用户信息')
      this.$router.push({ path: '/personalCenter' })
      return
    }
    this.examUserBaseI = JSON.parse(localStorage.userInfo) || ''
    this.getQueryList()


  },
  components: { Popover: () => import('@/components/Popover.vue'), Modal, PayQrDialog, paymentVoucher },
  data() {
    return {
      pvData: {
        id: 0,
        pvShow: false,
      },
      showPayDialog: false,
      rowHeight: 0, //表格行高
      tableHeight: window.innerHeight - 245,
      recordId: '', //当前这条记录的id

      modalShow: false, //报名弹窗是否显示
      row: {},

      resList: [],
      userId: JSON.parse(localStorage.getItem('userInfo')).userId,
      examId: '',
      listQuery: {
        pageNum: 1,
        pageSize: 100,
        condition: {
          institutionId: '',
          userId: JSON.parse(localStorage.getItem('userInfo')).userId
        }
      },
      total: 0,
      detailVisible: false,
      detailText: '',
      examUserBaseI: '',
      qrUrl: ''
    }
  },
  filters: {
    parseTime(val) {
      return parseTime(val, '{y}-{m}-{d} {h}:{i}') || '--'
    }
  },
  computed: {
    ...mapState({
      queryList: state => state.registrationQuery.queryList
    }),
    rangeTime() {
      return time => moment().isBetween(...time)
    },
    diffTime() {
      return time => moment().valueOf() < time
    }
  },
  methods: {
    paymentVoucherClose(){
      this.pvData.pvShow = false;
    },
    paymentVoucherShow(row) {
      console.log(row);
      this.pvData.pvShow = true;
      this.pvData.id = row.id;
      this.pvData.orderId = row.orderId;
    },
    initRowHeight() {
      let tableHeight =
        Math.round(this.$refs['paramRef'].$el.offsetHeight) -
        Math.round(this.$refs['paramRef'].$el.childNodes[1].offsetHeight)
      // 返回小于等于最终结果的最大整数
      this.rowHeight = Math.floor(tableHeight / 10)
    },
    //查看原因
    handleDetail(row) {
      this.detailText = row.examineDesc
      this.detailVisible = true
    },
    //获取列表
    getQueryList() {
      this.$store.dispatch('getQueryList', this.listQuery).then(res => {
        if (res) {
          this.total = res.total
          res.total > 0 && this.initRowHeight()
        }
      })
    },
    //点击编辑
    handleEdite(row) {
      this.modalShow = true
      this.row = row
    },
    toPay(row) {
      console.log(row.examModel?.payType);
      if (row.examModel?.payType === 'customChat') {
        this.showPayDialog = true
        this.row = row
      } else {
        getPay(row.id).then(res => {
          console.log(res);
          if (!res) return
          if (res.qrCode) {
            this.showPayDialog = true
            this.qrUrl = res.qrCode
          } else {
            let routerData = this.$router.resolve({
              path: '/registrationQuery/payPage',
              query: { htmlData: res.form }
            })
            window.open(routerData.href, '_ blank')
          }
        })
      }
    },
    /* 报名 */
    register(list) {
      const examUserBaseI = this.examUserBaseI
      const params = list.slice(0, -1).map(item => {
        return {
          infoKey: item.infoKey,
          infoName: item.infoName,
          infoType: item.infoType,
          infoValue: item.prop,
          examUserBaseId: examUserBaseI.userId,
          id: item.id
        }
      })
      // return;
      let result = {
        examId: this.row.examId,
        examUserBaseId: examUserBaseI.userId,
        examUserExtendParams: params,
        examDetailIds: list.slice(-1)[0].examDetailIds,
        id: this.row.id
      }

      this.$store
        .dispatch('submitPersonInfo', result)
        .then(res => {
          //判断状态，关闭弹窗
          this.$message.success('设置成功')
          this.modalShow = false
          this.getQueryList()
        })
        .catch(err => {
          this.$message.success(err)
        })
    },
    handleClose() {
      this.detailVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 320px) and (max-width: 768px) {
  @import '../styles/registrationQuery.mobile';
}
@media screen and (min-width: 769px) {
  @import '../styles/registrationQuery.pc';
}
</style>
